import { createTheme, useTheme as useWeaveTheme } from '@mui/material';

import { type AlloyTheme, getAccWeaveTheme } from '../accTheme';
import type { ThemeId } from '../constants';
import { WEAVE_THEME_ID } from '../constants';
import { type WeaveTheme } from '../types/weaveTypes';

export type CombinedTheme = (WeaveTheme & AlloyTheme) & {
  id: ThemeId;
};
type MaybeCombinedTheme = WeaveTheme | CombinedTheme;

const isCombinedTheme = (theme: MaybeCombinedTheme): theme is CombinedTheme => {
  // this component does not exist in the weave theme
  return (theme as AlloyTheme).tokens?.component?.a !== undefined;
};

export const useTheme = (): CombinedTheme => {
  const maybeAlloyTheme = useWeaveTheme<MaybeCombinedTheme>();

  if (isCombinedTheme(maybeAlloyTheme)) {
    return maybeAlloyTheme;
  }

  const weaveTheme = maybeAlloyTheme;

  const accWeaveTheme = getAccWeaveTheme(weaveTheme);

  // If the theme has tokens (pure Weave theme), use WEAVE_THEME_ID
  // Otherwise getAccWeaveTheme returns alloyTheme with ALLOY_THEME_ID
  if (weaveTheme.tokens) {
    return createTheme(weaveTheme, accWeaveTheme, {
      id: WEAVE_THEME_ID,
    }) as CombinedTheme;
  }
  return createTheme(weaveTheme, accWeaveTheme) as CombinedTheme;
};

export const isWeaveTheme = (theme: CombinedTheme) =>
  theme.id === WEAVE_THEME_ID;
